import { render, staticRenderFns } from "./historiaClinicaConfig.vue?vue&type=template&id=277dd75e&scoped=true&"
import script from "./historiaClinicaConfig.vue?vue&type=script&lang=js&"
export * from "./historiaClinicaConfig.vue?vue&type=script&lang=js&"
import style0 from "./historiaClinicaConfig.vue?vue&type=style&index=0&id=277dd75e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277dd75e",
  null
  
)

export default component.exports